<template>

  <t-page>


    <t-page-form multi-cards :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <t-input v-model="form.roleId" hidden/>


      <t-input v-model="form.name"  :add-error="error.name" label="Nome" required/>

      <t-input v-model="form.federalClassification" label="CBO" help="Classificação Brasileira de Ocupações" />



      <div class="mt-3 mb-3">

        <b-card-title>Exames relacionados a esta função</b-card-title>

        <t-table
            enable-checked
            v-model="form.examIds"
            :items="examList"
            :fields="viewFieldsPageExam"
            title-items="Exames"
            link-primary-column="name"
            table-bordered
            disable-actions-column
            primary-key-column="examId">

          <template #first-column="{item}">
            {{ item.name }}
          </template>

          <template #item(qtyValidatePeriodDefault)="{item}">
            {{ item.qtyValidatePeriodDefault }} meses
          </template>

        </t-table>


      </div>

      <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

      <t-input-status v-model="form.status"/>


    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"

import ui from "@/assets/scripts/ui";
import ExamService from "@/services/modules/employee/Exam.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'FeatureForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: true,
      fieldKey: "roleId",
      form: {
        roleId: 0,
        name: "",
        federalClassification: "",
        note: "",
        examIds: [],
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      viewFieldsPageExam: [
        {key: "name", label: "Exame"},
        {key: "qtyValidatePeriodDefault", label: "Vencimento"},
        {key: "note", label: "Obs."},
      ],//Listagem completa
      examList: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      await ExamService.getAllExams().then((list) => {
        this.examList = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      if (this.form.examIds.length === 0) {
        ui.msgError(this, "Selecione pelo menos 1 exame relacionado a esta função para continuar.")
      } else {
        await this.setSendingDefault()
      }


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
